import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Home.css';

const Home = ({ onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="home-page module-home-page">
      <Header />
      <div className="page-body">
        <main className="home-main module-home-main" aria-label="Home">
          <section className="module-home-surface">
            <div className="module-home-content">
              <div className="module-card-row" aria-label="Modules">
                <button
                  type="button"
                  className="module-card"
                  onClick={() => navigate('/crm?module=fnol')}
                >
                  FNOL
                </button>
                <button
                  type="button"
                  className="module-card"
                  onClick={() => navigate('/my-work')}
                >
                  Adjuster Assist
                </button>
              </div>
              <div className="module-hero-visual" aria-hidden="true">
                <img
                  className="home-hero-photo"
                  src="/images/adjuster-assist-home-hero.png"
                  alt=""
                />
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
